module.exports = __webpack_public_path__ + "static/img/common.7f0a9fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/home/pc/common.png
// module id = CPqL
// module chunks = 7